export default __webpack_public_path__ + "static/media/two-gis-disabled.62eb014c.svg";